import React from "react";
import { useTranslation } from "react-i18next";
import { AllDataAccount } from "../../../generated/types";
import { EntityCard } from "../../common/EntityCard";
import { UserTypeBadge } from "./UserTypeBadge";

type UserMobileCardProps = {
  data: AllDataAccount;
  isFavorite: boolean;
  onToggleFavorite: (e: React.MouseEvent) => void;
  onSelect?: () => void;
};

export const UserMobileCard = ({
  data,
  isFavorite,
  onToggleFavorite,
  onSelect,
}: UserMobileCardProps) => {
  const { t } = useTranslation();
  if (!data?.account) return null;

  return (
    <EntityCard
      title={data.account.first_name + " " + data.account.last_name}
      isFavorite={isFavorite}
      onToggleFavorite={onToggleFavorite}
      onClick={onSelect}
      rows={[
        {
          label: t("account-type"),
          value: <UserTypeBadge type={data.account.type} />,
        },
        { label: t("company"), value: data.company.company_name || "-" },
        { label: t("account-email"), value: data.account.email || "-" },
      ]}
    />
  );
};
